import * as React from 'react';
import { OnboardingTooltip } from '@cian/ui-kit';

import { MapRouteOnboardingContent } from '../MapRouteOnboardingContent';

export interface IMapRouteOnboardingProps {
  children: React.ReactElement;
  onClose(): void;
  open: boolean;
}

export const MapRouteOnboarding: React.FC<IMapRouteOnboardingProps> = ({ children, onClose, open }) => {
  return (
    <OnboardingTooltip open={open} onClose={onClose} content={<MapRouteOnboardingContent />} placement="bottom">
      {children}
    </OnboardingTooltip>
  );
};
